import Token from '@web/common/token'
import PAGE_NAME from '@web/consts/PAGE_NAME'
import { useStore } from '@web/store'
import { User } from '@web/store/types/modules/user'
import urlParse from 'url-parse'
import { useRouter } from 'vue-router'

export function useRedirectAfterLogin () {
  const router = useRouter()
  const store = useStore()

  async function redirectAfterLogin (user?: User) {
    if (user && user?.requiredUpdateProfile) {
      router.push({ name: PAGE_NAME.UPDATE_PROFILE })
      return
    }

    const returnUrlFromQuery: string | null = router.currentRoute.value.query.returnUrl as string | null
    const returnUrlFromStore: string = store.state.main.returnUrl

    function openExternal (url: string): void {
      const URLParseInstance = urlParse(url, true)
      URLParseInstance.set('query', {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ...URLParseInstance.query,
        token: Token.get()
      })
      window.location.href = URLParseInstance.toString()
    }

    function openInternal (route: string | object): void {
      router.push(route)
    }

    if (returnUrlFromQuery) {
      openExternal(returnUrlFromQuery)
    } else if (/^https?:\/\//.test(returnUrlFromStore)) {
      openExternal(returnUrlFromStore)
    } else if (returnUrlFromStore && returnUrlFromStore !== '/') {
      openInternal(returnUrlFromStore)
    } else {
      openInternal({ name: PAGE_NAME.HOME })
    }
  }

  return {
    redirectAfterLogin
  }
}

export default useRedirectAfterLogin
